const RemoteAssistanceDisplayBoxStyle = `
  margin: 0 0 65px;
`;

export default RemoteAssistanceDisplayBoxStyle;
